var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-20px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.54199C5.88071 2.54199 2.5415 5.8812 2.5415 10.0003C2.5415 14.1194 5.88071 17.4587 9.99984 17.4587C14.119 17.4587 17.4582 14.1194 17.4582 10.0003C17.4582 5.8812 14.119 2.54199 9.99984 2.54199ZM0.791504 10.0003C0.791504 4.9147 4.91422 0.791992 9.99984 0.791992C15.0855 0.791992 19.2082 4.9147 19.2082 10.0003C19.2082 15.0859 15.0855 19.2087 9.99984 19.2087C4.91422 19.2087 0.791504 15.0859 0.791504 10.0003ZM9.99984 4.12533C10.4831 4.12533 10.8748 4.51708 10.8748 5.00033V9.45955L13.7245 10.8844C14.1567 11.1005 14.3319 11.6261 14.1158 12.0583C13.8997 12.4905 13.3741 12.6657 12.9419 12.4496L9.60853 10.7829C9.31209 10.6347 9.12484 10.3318 9.12484 10.0003V5.00033C9.12484 4.51708 9.51659 4.12533 9.99984 4.12533Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock.43246952.svg";
export { ForwardRef as ReactComponent };